var shopMoreSlider = {
  init: function init() {
    var $shopMoreSlider = $('.js-shop-more-slider');
    var options;
    if ($shopMoreSlider.length === 0) {
      return;
    }
    $.each($shopMoreSlider, function () {
      var $shopMoreSliderInstance = $(this);
      var $sliderLength = $shopMoreSliderInstance.find('.shop-more-item').length;
      if ($sliderLength <= 4) {
        options = {
          cellAlign: 'center',
          prevNextButtons: false,
          pageDots: false,
          dragThreshold: 10,
          wrapAround: false,
          contain: true,
          draggable: matchMedia('screen and (min-width: 992px)').matches ? false : true,
          on: {
            ready: function ready() {
              setTimeout(function () {
                $shopMoreSliderInstance.removeClass('invisible').addClass('ready');
              }, 1000);
            }
          }
        };
      } else {
        options = {
          cellAlign: 'left',
          prevNextButtons: true,
          pageDots: false,
          dragThreshold: 10,
          wrapAround: false,
          contain: true,
          on: {
            ready: function ready() {
              setTimeout(function () {
                $shopMoreSliderInstance.removeClass('invisible').addClass('ready');
              }, 1000);
            }
          }
        };
      }
      $shopMoreSliderInstance.flickity(options);
    });
  }
};
shopMoreSlider.init();
export default shopMoreSlider;


// WEBPACK FOOTER //
// ./scripts/components/sliders/shop-more.js